document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    var swiper = new Swiper(".swiper-js", {
        slidesPerView: 1,
        loop: true,
        // autoplay: {
        //     delay: 4600,
        //     disableOnInteraction: false,
        // },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<div class="' + className + '" number="'+'0' + (index + 1)+'">' + '<span class="bullet">' + ' <svg width="50" height="50" viewBox="-11.125 -11.125 111.25 111.25" version="1.1" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(-90deg)"><circle r="34.5" cx="44.5" cy="44.5" stroke="#A3915E" stroke-width="6" stroke-linecap="round" stroke-dashoffset="210px" fill="transparent" stroke-dasharray="216.66px"></circle></svg> ' + '</span>' + '</div>';
            },
        },
        navigation: {
            nextEl: ".swiper-button-next-slide",
            prevEl: ".swiper-button-prev-slide",
        },
    });

    var swiperReviews = new Swiper(".swiper-reviews", {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-button-next-reviews",
            prevEl: ".swiper-button-prev-reviews",
        },
        autoplay: {
            delay: 4600,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<div class="' + className + '">' + '<svg width="50" height="50" viewBox="-11.125 -11.125 111.25 111.25" version="1.1" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(-90deg)"><circle r="34.5" cx="44.5" cy="44.5" stroke="#A3915E" stroke-width="6" stroke-linecap="round" stroke-dashoffset="210px" fill="transparent" stroke-dasharray="216.66px"></circle></svg>' + '<span class="bullet">' + '</span>' + '</div>';
            },
        },
    });

    var swiperNormal = new Swiper(".swiper-normal", {
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next-normal",
            prevEl: ".swiper-button-prev-normal",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    var swiperAmenities = new Swiper(".swiper-amenities", {
        loop: false,
        spaceBetween: 20,
        navigation: {
            nextEl: ".swiper-button-next-amenities",
            prevEl: ".swiper-button-prev-amenities",
        },
        breakpoints: {
            600: {
                slidesPerView: 3
            },
            780: {
                slidesPerView: 6
            }
        }
    });

    var swiperAmenities = new Swiper(".swiper-amenities-mobile", {
        slidesPerView: 2,
        loop: false,
        spaceBetween: 20,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    var swiperNew = new Swiper(".swiperNew", {
        slidesPerView: 1,
        loop: false,
        centerMode: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<div class="' + className + '">' + '<svg width="50" height="50" viewBox="-11.125 -11.125 111.25 111.25" version="1.1" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(-90deg)"><circle r="34.5" cx="44.5" cy="44.5" stroke="#A3915E" stroke-width="6" stroke-linecap="round" stroke-dashoffset="210px" fill="transparent" stroke-dasharray="216.66px"></circle></svg>' + '<span class="bullet">' + '</span>' + '</div>';
            },
        },
        // autoplay: {
        //     delay: 4600,
        //     disableOnInteraction: false,
        // },
        navigation: {
            nextEl: ".swiper-button-next-new",
            prevEl: ".swiper-button-prev-new",
        },
        breakpoints: {
            340: {
                spaceBetween: 10
            },
            650:{
                spaceBetween: 30
            }
        }
    });

    var swiperSpecials = new Swiper(".swiperSpecials", {
        slidesPerView: 3,
        loop: false,
        centerMode: true,
        spaceBetween: 30,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<div class="' + className + '">' + '<svg width="50" height="50" viewBox="-11.125 -11.125 111.25 111.25" version="1.1" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(-90deg)"><circle r="34.5" cx="44.5" cy="44.5" stroke="#A3915E" stroke-width="6" stroke-linecap="round" stroke-dashoffset="210px" fill="transparent" stroke-dasharray="216.66px"></circle></svg>' + '<span class="bullet">' + '</span>' + '</div>';
            },
        },
        navigation: {
            nextEl: ".swiper-button-next-specials",
            prevEl: ".swiper-button-prev-specials",
        },
        breakpoints: {
            340: {
                slidesPerView: 1
            },
            768:{
                slidesPerView: 2
            },
            1024:{
                slidesPerView: 3
            }
        }
    });

    var swiperGallery = new Swiper(".swiperGallery", {
        centeredSlides: true,
        loop: true,
        breakpoints: {
            340: {
                slidesPerView: 1.2,
                centeredSlides: true,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 30,
                centeredSlides: false,
            },
            1060: {
                slidesPerView: 2.5,
                spaceBetween: 20,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next-gallery',
            prevEl: '.swiper-button-prev-gallery',
        },
    });

    var swiperPackages = new Swiper(".swiperPackages", {
        slidesPerView: 3,
        loop: false,
        spaceBetween: 30,
        breakpoints: {
            340: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
        autoplay: {
            delay: 4600,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<div class="' + className + '">' + '<svg width="50" height="50" viewBox="-11.125 -11.125 111.25 111.25" version="1.1" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(-90deg)"><circle r="34.5" cx="44.5" cy="44.5" stroke="#A3915E" stroke-width="6" stroke-linecap="round" stroke-dashoffset="210px" fill="transparent" stroke-dasharray="216.66px"></circle></svg>' + '<span class="bullet">' + '</span>' + '</div>';
            },
        },
        navigation: {
            nextEl: ".swiper-button-next-packages",
            prevEl: ".swiper-button-prev-packages",
        },
    });

});
